import React, { useEffect, useState } from 'react';
import QRCode from 'react-qr-code';
import { generateUUID } from './app/utils/utils';
import BaseLayout from './app/components/base_layout';

import './App.css';

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import 'font-awesome/css/font-awesome.css'
import API from './app/network/API';
import Wait from './app/components/wait';


function App() {

    const [value, setValue] = useState('moja mbili tatau')
    const [back, setBack] = useState('#FFFFFF')
    const [fore, setFore] = useState('#000000')
    const [size, setSize] = useState(256)
    const [message, setMessage] = useState('');

    useEffect(()=>{
        const ws = new WebSocket('wss://'+API.BASE_URL+'/ws/chat/e/');
        //const ws = new WebSocket('wss://'+API.BASE_URL+'/ws/chat/e/?token='+sessionStorage.getItem('token'));
        const uuid = generateUUID()
        Wait.show('Connecting..')
        ws.onopen = () => {
            console.log('WebSocket connection opened')
            setMessage(uuid);
            Wait.dismiss()
             //ws.send("{\"message\":\""+1234567890+"\"}");
        };

        // Event listener for incoming messages
        ws.onmessage = (event) => {
          //console.log('Message received:', event.data)

          let data = JSON.parse(event.data)
          console.log(data)

          if (data.type === 'reports') {
            if(data.uuid === uuid){
              const token = data.message
              sessionStorage.setItem('token', token)
              window.location.reload()
            }
          }


        };

        // Event listener for when the connection is closed
        ws.onclose = () => {
          console.log('WebSocket connection closed');
        };





        // Cleanup function to close the WebSocket connection when the component unmounts
        return () => {
          ws.close();
        };
      }, []); // Run this effect only once when the component mounts

    return (sessionStorage.getItem('token') !== null ? 
    <BaseLayout /> :  
    <div className={'dashboard'} style={{height:'100vh',width:'100vw',textAlign:'center',display:'flex',alignItems:'center',justifyContent:'center'}}>

            <div className={'u-card'}>
              
              <p>
                Scan the QR code below<br/>to get started
              </p>
               <QRCode
                        title="GeeksForGeeks"
                        value={message}
                        bgColor={back}
                        fgColor={fore}
                        size={size === '' ? 0 : size}
                    />
            </div>
          <Wait/>
        </div>
    );
}
 
export default App;